import { IconButton as I } from '@rmwc/icon-button';
import '@material/icon-button/dist/mdc.icon-button.css';

export const IconButton = I;
